module.exports = __webpack_public_path__ + "images/external_images/img/500x650/img1.jpg";